module.exports = __webpack_public_path__ + "media/v1/images/icons/socials/instagram-94bbc566c524bb4bf1ad218e0f3bb5dd.svg";